"use strict";

angular.module("customer")
.controller("GoodsReceiptDetailsController", function(
    $scope, $state, $stateParams, $timeout, gettextCatalog, GoodsReceiptService, GoodsReceiptStatusService,
    StocksService, PatternService, ProductDetailsModalService, FlashBag, FormError, common
) {
    $scope.search = {};
    $scope.isReadOnly = true;
    $scope.disableSubmitButton = false;
    $scope.isCollapsed = true;
    $scope.hasUnsavedChanges = false;
    $scope.pattern = PatternService;
    $scope.statusNames = GoodsReceiptStatusService.getStatusNamesTranslations();

    $scope.$watch("goodsReceiptForm.$dirty", function(newValue) {
        $scope.hasUnsavedChanges = newValue;
    });

    $scope.$on("doLiveSearch", function($event, searchTerm) {
        $scope.search = {$: searchTerm};
        $timeout(function() {
            if (searchTerm) {
                common.scrollTo(".value-select:first-of-type");
                if (angular.element(".items-listing").length === 1) {
                    angular.element(".value-select").first().focus().select();
                }
            }
        });
    });

    this.clearSearch = function() {
        $scope.$emit("clearSearch");
    };

    GoodsReceiptService.get($stateParams.id).$promise
    .then(function onSuccess(data) {
        $scope.goodsReceipt = data;
        $scope.isReadOnly = GoodsReceiptService.READONLY_STATUSES.indexOf($scope.goodsReceipt.status) !== -1 || $scope.goodsReceipt.products.length === 0;
    });

    this.showProductDetails = function(productId) {
        ProductDetailsModalService.showProductDetails(productId);
    };

    this.receive = function() {
        $scope.goodsReceiptForm.$setSubmitted();
        FlashBag.clearAll();

        if (!$scope.goodsReceiptForm.$valid) {
            FormError.focus("goodsReceiptForm");
            return;
        }

        $scope.disableSubmitButton = true;
        var data = angular.copy($scope.goodsReceipt);
        delete data.id;

        GoodsReceiptService.create(data)
        .then(function onSuccess(data) {
            FlashBag.success(gettextCatalog.getString("You successfully created the Goods Receipt."), true);
            if (data.goods_transfer) {
                var productErrors = data.goods_transfer.product_errors;
                if (data.goods_transfer.id) {
                    FlashBag.success(gettextCatalog.getString("You successfully created the Goods Transfer."), true);
                }
                showGoodsTransferErrors(
                    productErrors,
                    gettextCatalog.getString("Goods transfer products were not created:")
                );

                var apiError = data.goods_transfer.api_error;
                if (apiError) {
                    FlashBag.preformattedError(apiError, true);
                }

                $scope.hasUnsavedChanges = false;
                if (data.goods_transfer.id) {
                    $timeout(function() {
                        $state.transitionTo("goodsTransferDetails", {"id": data.goods_transfer.id}, {location: "replace"});
                    });
                }
            } else {
                $scope.hasUnsavedChanges = false;
                $timeout(function() {
                    $state.transitionTo($state.$current.name, {"id": data.id}, {location: "replace"});
                });
            }
        }, function onError(response) {
            FlashBag.apiError(response);
        }).finally(function() {
            $scope.disableSubmitButton = false;
        });
    };

    function showGoodsTransferErrors(productErrors, errorMessage) {
        if (productErrors && productErrors.length) {
            var message = "<strong>" + errorMessage + "</strong>";
            message += FlashBag.formatErrorList(productErrors);
            FlashBag.warning(message, true, null);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/goods-receipt/goods-receipt-details.controller.js
// module id = 953
// module chunks = 0